import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { SceneEmail } from '@elem/compCommon/SceneEmail';

export default function A() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('costsaving');
    const { locale } = useRouter();

    const isUs = ['us'].includes(locale);

    return (
        <div className={`cost-saving-A ${css['cost-saving-A']}`}>
            <div className="img-box">
                {isUs ? (
                    <EFPicture
                        src={'https://websiteoss.ecoflow.com/upload/image/1749108128078/costsavingKV_pc.jpg'}
                        srcMobile={'https://websiteoss.ecoflow.com/upload/image/1749108128354/costsavingKV_h5.jpg'}
                        alt={t('secA_title')}
                    />
                ) : (
                    <EFPicture
                        src={'/responsive/picture/cost-saving/1.jpg'}
                        srcPad={'/responsive/picture/cost-saving/1_768.jpg'}
                        srcMobile={'/responsive/picture/cost-saving/1_768.jpg'}
                        alt={t('secA_title')}
                    />
                )}
            </div>
            <div className="text-info">
                <h1 className="title">{t('secA_title')}</h1>
                {['us', 'ca'].includes(locale) ? (
                    <SceneEmail theme="white" type="COST_SAVING" title={t('secA_title')} />
                ) : (
                    <>
                        <p className="desc sub">
                            {t.rich('secA_desc', {
                                n: (text: any) => <span className="no-wrap">{text}</span>,
                            })}
                        </p>
                        {!isUs && (
                            <a className="btn" href="#cost-saving-B">
                                {t('secA_btn')}
                            </a>
                        )}
                    </>
                )}
            </div>
        </div>
    );
}
